// extracted by mini-css-extract-plugin
export default {"button":"tableButton_button__mwcZL"};